



















import { Component, Vue, PropSync, Prop } from 'vue-property-decorator'
import { IStringIndexed } from '@/modules/shared/types'
import Customer from '@/modules/customers/models/customer'
import Rules from '@/plugins/validations'

@Component
export default class CustomerGeneralFormFields extends Vue {
  @PropSync('customer', {
    required: true,
    default: () => new Customer()
  })
  private localCustomer!: IStringIndexed

  @Prop({ default: () => null })
  private validations!: IStringIndexed|null

  private get fieldRules () : IStringIndexed {
    const rules: IStringIndexed = {
      businessName: [Rules.required()],
      dba: []
    }

    if (this.validations !== null) {
      for (const p in this.validations) {
        rules[p] = this.validations[p]
      }
    }

    return rules
  }

  public mounted () {
  }
}
